import { useState } from "react";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Vision } from "./components/Vision";
import { Treatments } from "./components/Treatments";
import { Approach } from "./components/Approach";
import { Learning } from "./components/Learning";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { Impressum } from "./components/Impressum";
import "./index.css";

export function App() {
  const [impressumOpen, setImpressumOpen] = useState(false);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <About />
        <Vision />
        <Treatments />
        <Approach />
        <Learning />
        <Contact />
      </main>
      <Footer onImpressum={() => setImpressumOpen(true)} />
      <Impressum open={impressumOpen} onClose={() => setImpressumOpen(false)} />
    </>
  );
}

export default App;
